require('./accountDebitAnnulationPayments.scss');
const PropTypes = require('prop-types');
// @ vendors
const React = require('react');
const { connect } = require('react-redux');
const PureRenderMixin = require('react-addons-pure-render-mixin');
const { withRouter } = require('react-router-dom');
// @ helpers
const { formatText, FormattedText, getFinalTitle, getLanguage } = require('core/i18n').i18n;
const { getLastNChars } = require('utilities/stringHelper');
const { contactCenterAction } = require('utilities/conditionals/conditionalAction')
const ContactCenterRender = require('components/conditionalRender/contactCenterRender')
// @ actions
const postDebitAnnulation = require('actions/postDebitAnnulation');
const printerActions = require('actions/contactCenter/printer');
// @components
import OKLayout from 'components/commons/OKLayout/OKLayout';
const { OKSectionBox } = require('commonsComponents/OKSectionBox');
import { LabelDate } from 'commonsComponents/labelDate';
const OKInformativeList = require('components/rebrand/OKInformativeList/OKInformativeList');
const OKInformativeListItem = require('components/rebrand/OKInformativeListItem/OKInformativeListItem');
const { SignaturePattern } = require('components/signaturePattern/signaturePattern');
const { OKButton } = require('components/commons/OKButton/OKButton');
const AccountDebitAnnulationSuccess = require('components/accounts/accountDebits/accountDebitAnnulationSuccess/accountDebitAnnulationSuccess');
const AccountDebitAnnulationFailure = require('components/accounts/accountDebits/accountDebitAnnulationFailure/accountDebitAnnulationFailure');
const TutorialLauncher = require('components/tutorial/tutorialLauncher');
const PreLeaveModalComponent = require('components/preLeaveModalComponent/preLeaveModalComponent');
// @ constants
import { LABEL_DATE_TODAY, LABEL_DATE_YESTERDAY } from 'constants/commonsComponents';
const { DEBIT_CANCELLATION_NEXT_PAYMENTS } = require('constants/operationTypes');
const {
    API_ENTERPRISE_NUMBER,
    API_CENTER,
    ACCOUNT_DEBITS_HAS_BEEN_ANNULATED,
    GRAPHIC_TUTOR_TYPE_3
} = require('constants/index');
const { accountConstants } = require('utilities/accessHelperConditions/accounts');
import { NEGATIVE } from 'constants/layout';
//@utilities
const AccessHelper = require('utilities/accessHelper');
const { formatIbanString } = require('commonsUtilities/stringHelper');
const receiptNumberHelper = require('utilities/receiptNumberHelper');
// @ Contact Center
const { ConfirmationScript, CONFIRMATION_SCRIPT_GREETING, CONFIRMATION_SCRIPT_AGREEMENT } = require('components/contactCenter/confirmScript/confirmationScript');

class AccountDebitAnnulationPayments extends React.Component {
    constructor(props) {
        super(props);
        this.shouldComponentUpdate = PureRenderMixin.shouldComponentUpdate.bind(this);
        this.isReady = this.isReady.bind(this);
    }

    componentDidMount() {
        const { history, immAccounts, match: { params: { accountId } }, debitAnnulationWillCancel, resetPrintedIndicators } = this.props;

        AccessHelper.allowAccess(accountConstants.ACCOUNTS_DEBIT_ANNULATION_PAYMENT, {
            immAccounts,
            accountId
        }, history);

        debitAnnulationWillCancel();
        contactCenterAction(resetPrintedIndicators);
    }

    breadcrumb = (accountId) => {
        return [
            {
                text: formatText('breadcrumb-accounts'),
                url: '/myprofile/accounts'
            },
            {
                text: formatText('breadcrumb-debits'),
                url: `/myprofile/accounts/${accountId}/debits`
            },
            {
                text: formatText('breadcrumb-debitCancel'),
                url: ''
            }
        ];
    }

    buildReceiptFailureView() {
        const { match: { params: { accountId } } } = this.props;
        return <AccountDebitAnnulationFailure accountId={accountId} />;
    }

    buildReceiptSuccessView() {
        const { immReceipt, match: { params: { accountId, receiptNumber } } } = this.props;
        const receiptStatus = immReceipt.get('status');
        const authorizationId = immReceipt.get('authorizationId');

        return (
            <AccountDebitAnnulationSuccess
                accountId={accountId}
                receiptNumber={receiptNumberHelper(receiptNumber)}
                receiptStatus={receiptStatus}
                issuingCompanyId={authorizationId}
            />
        );
    }

    buildReceiptView() {
        const { immAccount, immAuthorization, immReceipt } = this.props;
        const alias = immAccount.get('alias');
        const fullIban = immAccount.get('iban');
        const ibanFormatted = getLastNChars(fullIban);
        const accountInCharge = alias + ibanFormatted;
        const accountInChargePrint = `${alias} ${formatIbanString(fullIban)}`;
        const issuingCompanyName = immReceipt.get('nombre');
        const authorizationId = immReceipt.get('authorizationId');
        const beneficiaryName = immReceipt.get('titular');
        const date = immAuthorization.get('fechaFirma');
        const originAccount = API_ENTERPRISE_NUMBER.concat(
            API_CENTER,
            immAccount.get('newProduct'),
            immAccount.get('newContractNumber')
        );
        const operationParams = {
            originAccount
        };

        const operativeName = formatText('operatives-accountDebitAnnulation');

        const acceptText = formatText('wizard-redirectConfirmationAcceptButton');
        const cancelText = formatText('wizard-redirectConfirmationCancelButton');
        const confirmationTitle = formatText('wizard-redirectConfirmationTitle');
        const confirmationMessage = formatText('wizard-redirectConfirmationMessage');
        const printTitleValue = __CONTACT_CENTER__ && 'accountDebits-cancelAuthorization';

        return (
            <div>
                <PreLeaveModalComponent
                    confirmationMessage={confirmationMessage}
                    confirmationTitle={confirmationTitle}
                    acceptText={acceptText}
                    cancelText={cancelText}
                    isReady={this.isReady}
                />
                <div className="account-debits-annulation__title">
                    <FormattedText value="accountDebitAnnulation-title" />
                </div>
                <div id="printable-wizard" >
                    <ContactCenterRender>
                        <ConfirmationScript operative={operativeName} confirmationType={CONFIRMATION_SCRIPT_GREETING} />
                    </ContactCenterRender>
                    <div className="account-debits-annulation__text">
                        <FormattedText value="accountDebitAnnulation-text" />
                    </div>
                    <div className="account-debits-annulation__header-container">
                        <OKInformativeList columns={3}>
                            <OKInformativeListItem
                                title={formatText('accountDebit-issuingCompanyName')}
                                bodyText={issuingCompanyName}
                            />
                            <OKInformativeListItem
                                title={formatText('accountDebit-beneficiaryName')}
                                bodyText={beneficiaryName}
                            />
                            <OKInformativeListItem
                                bodyText={accountInCharge}
                                className="no-print-out"
                                title={formatText('accountDebit-ibanFormatted')}
                            />
                            <OKInformativeListItem
                                bodyText={accountInChargePrint}
                                className="account-debits-annulation__print-only-iban"
                                title={formatText('accountDebit-ibanFormatted')}
                            />
                        </OKInformativeList>
                        <OKInformativeList columns={3}>
                            <OKInformativeListItem
                                title={formatText('accountDebit-issuingCompanyId')}
                                bodyText={authorizationId}
                            />
                            <OKInformativeListItem
                                title={formatText('accountDebits-activationDate')}
                                bodyText={this.renderDateCell(date)}
                            />
                            <div className="col-xs-4" />
                        </OKInformativeList>
                    </div>
                </div>
                <ContactCenterRender>
                    <ConfirmationScript confirmationType={CONFIRMATION_SCRIPT_AGREEMENT} />
                </ContactCenterRender>
                <div className="account-debits-annulation__signature-container">
                    <SignaturePattern
                        operationType={DEBIT_CANCELLATION_NEXT_PAYMENTS}
                        operationParams={operationParams}
                        printTitleValue={printTitleValue}
                    />
                </div>
                <div className="row account-debits-annulation__actions-container">
                    <div className="col-xs-6">
                        <OKButton
                            modifier="link-ghost"
                            size="regular"
                            onClick={this.handleCancel}
                        >
                            <FormattedText value="accountDebitAnnulation-cancel" />
                        </OKButton>
                    </div>
                    <div className="col-xs-6 text-right">
                        <OKButton
                            modifier="primary"
                            size="regular"
                            onClick={this.handleDebitAnnulation}
                        >
                            <FormattedText value="accountDebitAnnulation-annulate" />
                        </OKButton>
                    </div>
                </div>

            </div>
        );
    }

    handleCancel = () => {
        const { debitAnnulationWillCancel, match: { params: { accountId } }, history } = this.props;
        debitAnnulationWillCancel();
        history.push(`/myprofile/accounts/${accountId}/debits`);
    }

    handleDebitAnnulation = () => {
        const { immReceipt } = this.props;
        this.props.postDebitAnnulation(immReceipt);
    }

    isReady() {
        return false;
    }

    renderDateCell = (date) => {
        return (
            <LabelDate
                date={date}
                language={getLanguage()}
                today={LABEL_DATE_TODAY}
                yesterday={LABEL_DATE_YESTERDAY}
            />
        )
    }

    renderTutorial = () => {
        return (
            <TutorialLauncher
                type={GRAPHIC_TUTOR_TYPE_3}
                title={formatText('tutorials-nullReceiptTitle')}
            />
        );
    }

    renderAnnulation = (submitSuccessful, errorMessage) => {
        if (submitSuccessful) {
            return this.buildReceiptSuccessView();
        } else {
            if (!!errorMessage && errorMessage === ACCOUNT_DEBITS_HAS_BEEN_ANNULATED) {
                return this.buildReceiptFailureView();
            } else {
                return this.buildReceiptView();
            }
        }
    }

    render() {
        const { immAccount, immDebitAnnulation, match: { params: { accountId } } } = this.props;
        immAccount.getIn(['byId', accountId]);
        const submitSuccessful = immDebitAnnulation.get('submitSuccessful');
        const errorMessage = immDebitAnnulation.getIn(['errorReceived', 'text']);

        return (
            <OKLayout
                breadcrumb={this.breadcrumb(accountId)}
                className="account-debits-annulation"
                title={getFinalTitle('landingHeader-annulation')}
                loading={!(immAccount && immAccount.size)}
                section="accounts"
                contentPosition={NEGATIVE}
                tutorial={this.renderTutorial()}
            >
                <OKSectionBox>
                    <div className="row">
                        <div className="col-xs-12">
                            {this.renderAnnulation(submitSuccessful, errorMessage)}
                        </div>
                    </div>

                </OKSectionBox>
            </OKLayout>
        )
    }
}
AccountDebitAnnulationPayments.propTypes = {
    match: PropTypes.object.isRequired,
    history: PropTypes.object.isRequired,
    immAccount: PropTypes.object.isRequired,
    immAccounts: PropTypes.object.isRequired,
    immAuthorization: PropTypes.object.isRequired,
    immReceipt: PropTypes.object.isRequired,
    resetPrintedIndicators: PropTypes.func.isRequired,
    postDebitAnnulation: PropTypes.func.isRequired,
    immDebitAnnulation: PropTypes.object.isRequired,
    debitAnnulationWillCancel: PropTypes.func.isRequired
};
module.exports.constructor = AccountDebitAnnulationPayments;
module.exports.AccountDebitAnnulationPayments = withRouter(connect(
    (state, ownProps) => {
        const receipt = state.receipts.getIn([ownProps.match.params.accountId, 'byId', ownProps.match.params.receiptNumber]);
        return {
            immAccount: state.accounts.getIn(['byId', ownProps.match.params.accountId]),
            immAccounts: state.accounts,
            immAuthorization: state.authorizations.getIn([ownProps.match.params.accountId, 'byId', receipt.get('authorizationId')]),
            immReceipt: receipt,
            immDebitAnnulation: state.accountDebitAnnulation
        }
    },
    {
        postDebitAnnulation: postDebitAnnulation.postDebitAnnulation,
        resetPrintedIndicators: printerActions.resetPrintedIndicators,
        debitAnnulationWillCancel: postDebitAnnulation.debitAnnulationWillCancel
    }
)(AccountDebitAnnulationPayments));
